export default "__VITE_ASSET__1ffe0600__"